import React from 'react';
import { Handle as OwnHandle } from './wrapper';
import { SliderItem, GetHandleProps } from 'react-compound-slider';

interface IHandleProps {
  domain: number[];
  handle: SliderItem;
  getHandleProps: GetHandleProps;
  'aria-label'?: string;
}

export const Handle = ({
  domain: [min, max],
  handle: { id, value, percent },
  getHandleProps,
  'aria-label': ariaLabel,
}: IHandleProps) => (
  <OwnHandle
    role="slider"
    aria-label={ariaLabel}
    aria-valuemin={min}
    aria-valuemax={max}
    aria-valuenow={value}
    style={{
      left: `${percent}%`,
    }}
    {...getHandleProps(id)}
  />
);
